import { Question } from './Question'

export const QuestionList = ({ questions = [] }) =>
  questions.length > 0
    ? questions.map(({ id, nom_question }, index) => (
        <Question key={id} question={nom_question} id={id} index={index} />
      ))
    : 'No existe preguntas'
